module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boxbig"
  }, [_c('div', {
    staticClass: "topitem"
  }, [_c('div', {
    staticClass: "imgLeft"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "imgRight"
  }, [(_vm.userId) ? _c('el-dropdown', {
    staticClass: "user",
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n          " + _vm._s(_vm.phone.substring(0, 3) + "****" + _vm.phone.substring(7, 11))), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('i', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")])])], 1)], 1) : _c('el-link', {
    staticClass: "user",
    on: {
      "click": function($event) {
        return _vm.go('/sacrifice/login')
      }
    }
  }, [_vm._v("注册/登录")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navNew"
  }, [_c('nav', {
    staticClass: "nav f-db"
  }, _vm._l((_vm.navs), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.setactive(index, item.name)
        }
      }
    }, [_c('router-link', {
      class: _vm.active == index ? 'link-active' : 'link-default',
      attrs: {
        "to": {
          name: item.name,
          query: {
            id: item.id
          }
        }
      }
    }, [_vm._v(_vm._s(item.categoryTitle))])], 1)
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image_wrap"
  }, [_c('div', {
    staticClass: "logo"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2477e3cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/index.vue
// module id = Lr8B
// module chunks = 51